const initialState = {
  data: [],
};
  
const udzialyKontaAllAktReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_UDZIALY_KONTA_ALL_AKT':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default udzialyKontaAllAktReducer;